import { useMemo } from 'react'

import { type GroupMode } from 'types/ui'
import { type DropdownOption } from 'components/Dropdown/types'

export default function useGroupModeOption(
  groupMode: GroupMode,
  options: DropdownOption[]
): DropdownOption | undefined {
  return useMemo(
    (): DropdownOption | undefined =>
      options.find(({ value }) => value === groupMode),
    [groupMode, options]
  )
}
